export const DEFAULT_COLORS = {
  PRIMARY: "#1f4e78",
  PRIMARY_DARKER: "#183c5c",
  SECONDARY: "#fff",
  SECONDARY_DARKER: "#d9d9da",
  PROFILE_TEXT: "#212529 ",
  CANCEL_BUTTON: "#5f7478",
  CANCEL_BUTTON_HOVER: "#85a2a8"
};



// WEBPACK FOOTER //
// ./src/constants/colors.js